import * as jsxRuntime from "/Users/joeings/projects/shopifytest/shopifytest2/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment